import { ViewRoute } from "./types";
import { RouteNames } from "@dcc/router/definitions";

export const WelcomeRoute: ViewRoute = {
  [RouteNames.welcome]: () => {
    return RouteNames.profile;
  }
};
